import React from 'react'

export const InspirationTreeList = React.createContext({})
